import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-homepage.jpg";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 md:pt-20">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={heroImage}
          alt=""
          width={1920} height={1080}
          fetchPriority="high"
          loading="eager"
          className="w-full h-full object-cover object-[center_55%]"
        />
        <div className="absolute inset-0 bg-primary/60" />
      </div>
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-4xl flex flex-col justify-between min-h-[400px] md:min-h-[450px]">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight drop-shadow-lg">
            {t('hero.title')}
          </h1>
          
          <div className="mt-auto">
            <p className="text-lg md:text-xl text-white mb-8 max-w-2xl drop-shadow-md">
              {t('hero.subtitle')}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg"
                className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold text-lg h-14 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all"
                asChild
              >
                <a href="https://calendly.com/wilco-datastudent/15" target="_blank" rel="noopener noreferrer">
                  {t('hero.cta1')}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
